import {
    ArrowRightIcon,
    BodyMediumEmphasized,
    BodySmallRegular,
    Button,
    ButtonVariant,
    Checkbox,
    View,
    XStack,
    YStack,
} from 'smoothie';

interface CtaCardProps {
    layout: 'widget' | 'normal';
    title: string;
    description: string;
    ctaLabel: string;
    isMarkedComplete: boolean;
    onToggleComplete: () => void;
    onPressCta: () => void;
}

const AdoptionChecklistItem = ({
    layout = 'normal',
    title,
    description,
    ctaLabel,
    isMarkedComplete,
    onToggleComplete,
    onPressCta,
}: CtaCardProps) => {
    return (
        <XStack
            key={title}
            backgroundColor="$gray200"
            borderRadius={layout === 'widget' ? 0 : 16}
            height={layout === 'widget' ? '100%' : 'auto'}
            maxHeight={layout === 'widget' ? 200 : undefined}
            gap={12}
            padding={16}
        >
            <Checkbox
                id={`${title.replace(/ /g, '-').toLocaleLowerCase()}-${layout}`}
                checked={isMarkedComplete}
                onPress={onToggleComplete}
            />
            <YStack
                flex={1}
                gap={8}
                alignItems="flex-start"
                marginTop={2}
                userSelect="none"
            >
                <BodyMediumEmphasized>{title}</BodyMediumEmphasized>
                <BodySmallRegular paddingRight={8} color="$gray1200">
                    {description}
                </BodySmallRegular>
                <View marginTop={4}>
                    <Button
                        hoverStyle={null}
                        icon={ArrowRightIcon}
                        iconPosition="right"
                        onPress={onPressCta}
                        padding={0}
                        text={ctaLabel}
                        tone="positive"
                        variant={ButtonVariant.TERTIARY}
                        width="auto"
                        height="auto"
                    />
                </View>
            </YStack>
        </XStack>
    );
};

export default AdoptionChecklistItem;
